// removed by extract-text-webpack-plugin
module.exports = {"location":"Location-hashed__location__3gpJh","location__icon":"Location-hashed__location__icon__1dCq0","location__address":"Location-hashed__location__address__1CWE-"};


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/schedules/LocationReadonlyView/Location-hashed.scss
// module id = 661
// module chunks = 0